module.exports = __webpack_public_path__ + "static/img/banner_2.b1c9b18.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner_2.jpg
// module id = /Asq
// module chunks = 0